import { WALLET_CREATE, WALLET_RESTORE, WALLET_BACKUP, WALLET_RECEIVE, WALLET_STORAGE, WALLET_UNLOCK, PASSWORD_CHANGE } from "../../constants/actions"

// CREATE
export const WALLET_CREATE_ACTIONS = {
  onPasswordChange: password => ({
    type: WALLET_CREATE.ON_PASSWORD_CHANGE,
    payload: password
  }),
  onRepeatPasswordChange: password => ({
    type: WALLET_CREATE.ON_REPEAT_PASSWORD_CHANGE,
    payload: password  
  }),
  onCreateWallet: password => ({
    type: WALLET_CREATE.ON_CREATE_WALLET,
    payload: password
  }),
  resetCreateWalletState: () => ({
    type: WALLET_CREATE.ON_RESET_STATE
  })
}

// RESTORE
export const WALLET_RESTORE_ACTIONS = {
  onRestoreWallet: (mnemonic, password) => ({
    type: WALLET_RESTORE.ON_RESTORE_WALLET,
    payload: {
      mnemonic,
      password
    }
  }),
  onMnemonicChange: value => ({
    type: WALLET_RESTORE.ON_MNEMONIC_CHANGE,
    payload: value
  }),
  onPasswordChange: password => ({
    type: WALLET_RESTORE.ON_PASSWORD_CHANGE,
    payload: password
  }),
  onRepeatPasswordChange: password => ({
    type: WALLET_RESTORE.ON_REPEAT_PASSWORD_CHANGE,
    payload: password  
  }),
  resetWalletRestoreState: () => ({
    type: WALLET_RESTORE.ON_RESET_STATE
  })
}

// BACKUP
export const WALLET_BACKUP_ACTIONS = {
  onCopyToClipboard: () => ({
    type: WALLET_BACKUP.ON_COPY_TO_CLIPBOARD
  }),  
  resetWalletBackupState: () => ({    
    type: WALLET_BACKUP.ON_RESET_STATE    
  })
}

// RECEIVE
export const WALLET_RECEIVE_ACTIONS = {
  onCopyToClipboard: () => ({
    type: WALLET_RECEIVE.ON_COPY_TO_CLIPBOARD
  }),  
  resetWalletReceiveState: () => ({    
    type: WALLET_RECEIVE.ON_RESET_STATE    
  })
}

// STORAGE
export const WALLET_STORAGE_ACTIONS = {
  checkWalletStorage: () => ({
    type: WALLET_STORAGE.ON_CHECK_STORAGE
  }),
}

// UNLOCK
export const WALLET_UNLOCK_ACTIONS = {
  onUnlockWallet: payload => ({ type: WALLET_UNLOCK.ON_UNLOCK_WALLET, payload }),

  onPasswordChange: password => ({
    type: WALLET_UNLOCK.ON_PASSWORD_CHANGE,
    payload: password
  }),

  resetUnlockState: () => ({
    type: WALLET_UNLOCK.ON_RESET_STATE
  }),

  lockWallet: () => ({ type: WALLET_UNLOCK.ON_LOCK_WALLET })

}

// PASSWORD CHANGE
export const PASSWORD_CHANGE_ACTIONS = {
  onPasswordChange: wallet => ({
      type: PASSWORD_CHANGE.ON_PASSWORD_CHANGE,
      payload: wallet
  }),
  onRepeatPasswordChange: password => ({
      type: PASSWORD_CHANGE.ON_REPEAT_PASSWORD_CHANGE,
      payload: password
  }),
  onPasswordChangeAction: password => ({
      type: PASSWORD_CHANGE.ON_PASSWORD_CHANGE_ACTION,
      payload: password
  }),
  resetPasswordChangeState: () => ({
      type: PASSWORD_CHANGE.ON_RESET_STATE
  })
}



// WEBPACK FOOTER //
// ./src/store/actions/wallet.js